import { render, staticRenderFns } from "./MobileSidenav.vue?vue&type=template&id=67011567&scoped=true&"
import script from "./MobileSidenav.vue?vue&type=script&lang=js&"
export * from "./MobileSidenav.vue?vue&type=script&lang=js&"
import style0 from "./MobileSidenav.vue?vue&type=style&index=0&id=67011567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67011567",
  null
  
)

export default component.exports